
@if (isSSR || (accessIsReady$|async)) {
  <layout-contentbars-wrapper>
    <layout-contentbar-top >
      <a routerLink="" class="logo" >
        <ui-logo [scaling]="64" [background]="true" openConsole></ui-logo>
      </a>
      <div class="left">
        <h2 class="page-title" [innerHTML]="pageTitle$|async"></h2>
      </div>
      <div class="right">
        <feedback-button></feedback-button>
      </div>
    </layout-contentbar-top>
    <router-outlet-fullscreen></router-outlet-fullscreen>
    <layout-contentbar-bottom [fixed]="true" >
      <layout-toolbar></layout-toolbar>
    </layout-contentbar-bottom>
  </layout-contentbars-wrapper>
}

<core-root-outlet></core-root-outlet>
<ui-confirmDialog header="Bestätigung erforderlich" icon="exclamation-triangle"></ui-confirmDialog>

